<template>
  <editBonStock :isEntree="false"/>
</template>

<script>
import editBonStock from '@/components/bonStock/editBonStock';
import { get } from '@/api/gabed/bonStock';

export default {
  components: {
    editBonStock,
  },
  async mounted() {
    if (this.$route.params.id) {
      const bon = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageStock.bonStock.modifSortie', { libelle: bon.lieuDeStockage.nomCommercial }));
    } else {
      this.setInformationPage(this.$t('pageStock.bonStock.creationSortie'));
    }
  },
};
</script>
